import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import axios from "axios";

import { useState, useCallback, useEffect } from "react";
import {
  faPenToSquare,
  faTrashCan,
  faCircleCheck,
} from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import QRCode from "react-qr-code";
// import ProthCard from './ProthCard';

import { useNavigate, useLocation, useParams } from "react-router-dom";
import { DateTime, Settings } from "luxon";

import "./Solon/solonCard.css";
import { dikastiriaLower } from "../Util/makeDikastiriaLowerCase";
import { prothesmiesNeasTaktikis, prothesmiesMikrodiaforon } from "prothesmies";
import { reverseDate } from "../../utils/reverseDate";
import { isEidikesCase, hasUsableDate } from "../../utils/eidikesProcedure";
import ProthesmiaRow from "./ProthesmiaRow";
// import ExtraInfo from '../Visual/ExtraInfo';
import Container from "../Visual/Container";
import { getTopiki } from "../../utils/getTopiki";
import StoixeiaDikasimou from "./Solon/StoixeiaDikasimou";
import Lawyers from "./Solon/Lawyers";
import Applicants from "./Solon/Applicants";
import Defendants from "./Solon/Defendants";
import Appeals from "./Solon/Appeals";
import Diakinisi from "./Solon/Diakinisi";
import { Detail } from "./Outsolon/Detail";

import eirinodikeiaDiadikasies from "../OutSolon/utils/eirinodikeiaDiadikasies.json";
import protodikeiaDiadikasies from "../OutSolon/utils/protodikeiaDiadikasies.json";
import efeteiaDiadikasies from "../OutSolon/utils/efeteiaDiadikasies.json";
import { transformDateFormat } from "../../utils/various";
Settings.defaultLocale = "el";

const dikastirioIndex = {
  Ειρηνοδικείο: "Ειρ",
  Πρωτοδικείο: "Μον",
  Εφετείο: undefined,
};

const details = {
  epidosi: "Επίδοση",
  paremvasi: "Παρέμβαση, προσεπίκληση, ανακοίνωση ή ανταγωγή",
  paremvasiProsek: "Παρέμβαση του προσεπικαλούμενου",
  protaseis: "Κατάθεση προτάσεων",
  prosthiki: "Κατάθεση προσθήκης",
  opsigeneis: "Οψιγενείς ή παραχρήμα αποδεικνυόμενοι ισχυρισμοί",
  opsigeneisAntikrousi: "Αντίκρουση σε οψιγενείς",
  antikrousiArt269: "Αντίκρουση μετά τη συζήτηση (Αρθ. 269 § 3)",
  proskomidi:
    "Προσκομιδή των αποδεικτικών από τους διαδίκους και η υποβολή του έγγραφου υπομνήματος του εναγομένου",
  proskomidiParemv:
    "Προσκομιδή των αποδεικτικών και η υποβολή του έγγραφου υπομνήματος της παρέμβασης ή της ανταγωγής",
  prosthikiParemv: "Κατάθεση προσθήκης επί της παρέμβασης ή της ανταγωγής",
};
const pedia = {
  apotelesma: "Αποτέλεσμα",
  arithmos_apofasis: "Αρ. Απόφασης",
  antikeimeno: "Αντικείμενο",
  arithmos_pinakiou: "Πινάκιο",
  eidos: "Είδος",
  diadikasia: "Διαδικασία",
};
function returnProthArray(proth) {
  const arr = [];
  Object.keys(proth).forEach((r) => {
    if (r.endsWith("Details")) return;
    if (!details[r]) return;
    arr.push({
      prothesmia: proth[r],
      onoma: details[r],
      eidos: r,
      details: proth[`${r}Details`],
    });
  });
  return arr;
}

Date.createFromMysql = function (mysql_string) {
  var t,
    result = null;

  if (typeof mysql_string === "string") {
    t = mysql_string.split(/[- :]/);

    //when t[3], t[4] and t[5] are missing they defaults to zero
    result = new Date(t[0], t[1] - 1, t[2], t[3] || 0, t[4] || 0, t[5] || 0);
  }

  return result;
};
function formatDate(date) {
  const newDate = new Date(Date.createFromMysql(date));

  const formatedDate = DateTime.fromISO(newDate.toISOString()).plus({
    minutes: Math.abs(new Date().getTimezoneOffset()),
  });
  return `${formatedDate.toLocaleString(
    DateTime.DATE_FULL
  )}, ${formatedDate.toLocaleString({
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  })}`;
}
function formatDateWithWeekDay(date) {
  const newDate = new Date(Date.createFromMysql(date));

  const formatedDate = DateTime.fromISO(newDate.toISOString()).plus({
    minutes: Math.abs(new Date().getTimezoneOffset()),
  });
  return `${formatedDate.toFormat("EEEE")}, ${formatedDate.toLocaleString(
    DateTime.DATE_FULL
  )}`;
}

const VSolonCard = ({
  singleCase,
  singleUpdates,
  prothesmiesSingle,
  handleDeleteCase,
  modifySingleCase,
  saveCase,
}) => {
  const [note, setNote] = useState(singleCase?.note);
  const [showProth, setShowProth] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [editing, setEditing] = useState(false);

  const [diadikasies, setDiadikasies] = useState([]);
  const [antikeimena, setAntikeimena] = useState([]);
  const [eidi, setEidi] = useState([]);

  const [userInput, setUserInput] = useState(
    JSON.parse(singleCase?.extra_info) ? JSON.parse(singleCase?.extra_info) : {}
  );
  useEffect(() => {
    let diad = [];
    if (singleCase.dikastirio === "Ειρηνοδικείο")
      diad = eirinodikeiaDiadikasies;
    if (singleCase.dikastirio === "Πρωτοδικείο") diad = protodikeiaDiadikasies;
    if (singleCase.dikastirio === "Εφετείο") diad = efeteiaDiadikasies;
    setDiadikasies(diad);
  }, [singleCase]);

  useEffect(() => {
    let ant = [];
    if (singleCase.diadikasia) {
      ant = diadikasies
        .filter((r) => {
          return r.diadikasia === singleCase.diadikasia;
        })[0]
        ?.antikeimena.map((k) => {
          return k.antikeimeno;
        });
    }

    setAntikeimena([...new Set(ant)]);
  }, [diadikasies, singleCase.diadikasia]);

  useEffect(() => {
    let eid = [];

    eid = diadikasies
      .filter((r) => r.diadikasia === singleCase.diadikasia)[0]
      ?.antikeimena?.filter(
        (k) => k.antikeimeno === userInput.antikeimeno
      )[0]?.eidi;

    setEidi(eid);
  }, [diadikasies, singleCase.diadikasia, antikeimena, userInput]);

  let params = useParams();

  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();

  const href = `https://mysolon.gr${location.pathname}/qr`;

  const [checkAppeal, setCheckAppeal] = useState(
    singleCase.check_appeal === 1 ? true : false
  );
  const handleInputChange = (event) => {
    let obj = { ...userInput };
    const key = event.currentTarget.name;
    obj[key] = event.currentTarget.value;
    setUserInput(obj);
  };

  useEffect(() => {
    setUserInput(
      JSON.parse(singleCase?.extra_info)
        ? JSON.parse(singleCase?.extra_info)
        : {}
    );
  }, [singleCase]);
  // const [state, updateState] = useState();

  const afmParam = params?.afm;

  // const forceUpdate = useCallback(() => updateState({}), []);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getEauction = async () => {
      try {
        const response = await axiosPrivate.post(
          `/outsolon/userinput`,
          JSON.stringify({ extra_info: userInput, id: singleCase.id }),
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          }
        );
      } catch (err) {
        console.error(err);
        if (!axios.isCancel(err)) {
          // do something
          navigate("/login", { state: { from: location }, replace: true });
        }
      }
    };
    Object.keys(userInput).length !== 0 && getEauction();

    //  (userInput);
    // const interval = setInterval(() => {
    //   getCases()
    // }, 10000)
    return () => {
      isMounted = false;
      controller.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInput]);

  useEffect(() => {
    setNote(singleCase.note);
  }, [singleCase]);

  const handleClicks = async (e) => {
    if (e.target.parentNode.getAttribute("data-icon") === "pen-to-square") {
      setShowEdit(!showEdit);
    }
    if (e.target.parentNode.getAttribute("data-icon") === "circle-check") {
      setShowEdit(!showEdit);
      try {
        const id = e.target.parentNode.getAttribute("data-key");
        await axiosPrivate.post("/cases/note", JSON.stringify({ id, note }), {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        });
      } catch (err) {
        console.error(err);
      }
    }
    if (
      e.currentTarget?.firstChild?.getAttribute("data-icon") === "trash-can"
    ) {
      try {
        const id = e.currentTarget.getAttribute("data-key");
        await axiosPrivate.patch("/cases", JSON.stringify({ key: id }), {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        });
        handleDeleteCase(id);
      } catch (err) {
        console.error(err);
      }
    }
    // if (e.target?.parentNode?.getAttribute('data-icon') === null) {
    //   handleOnClick()
    // }
  };

  const handleAppeal = async (e) => {
    setCheckAppeal(!checkAppeal);

    try {
      const id = e.target.getAttribute("data-key");
      await axiosPrivate.post(
        "/appeals",
        JSON.stringify({ id, check: !checkAppeal }),
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );
    } catch (err) {
      console.error(err);
    }
  };
  const handleProth = async (e) => {
    setShowProth(!showProth);
  };
  const handleOnClick = useCallback(() => {
    navigate(`/cases/${singleCase.id}`, { replace: false });
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
  }, [navigate, singleCase]);
  const res = /\d{2}\/\d{2}\/\d{4}/.exec(singleCase?.arithmos_pinakiou);
  let imerominia = res ? res[0].replaceAll("/", ".") : undefined;
  let dikasimos = imerominia
    ? reverseDate(imerominia.replaceAll(".", "-"))
    : undefined;
  const katathesiIsoDate = (() => {
    if (!singleCase?.katathesi) return undefined;
    const [d, m, y] = singleCase.katathesi.split("/");
    return d && m && y ? `${y}-${m}-${d}` : undefined;
  })();
  let prothesmies = [];
  if (
    (singleCase?.diadikasia === "taktiki" ||
      singleCase?.diadikasia.includes("ΝΕΑ")) &&
    singleCase.katathesi
  ) {
    prothesmies = returnProthArray(
      prothesmiesNeasTaktikis(singleCase.katathesi.replace(/\//g, "-"), {
        dikasimos: userInput.dikasimos.replace(/\//g, "-"),
        topiki: singleCase.topos,
        yliki: dikastirioIndex[singleCase.dikastirio],
        exoterikou: userInput.exoterikou === "Ναι",
        dimosio: userInput.dimosio === "Ναι",
        klisi: userInput.klisi === "Ναι",
      })
    ).filter(hasUsableDate);
  } else if (
    (singleCase?.diadikasia?.includes("mikro") ||
      singleCase?.diadikasia?.includes("ΜΙΚΡΟΔΙΑΦΟΡ")) &&
    singleCase.katathesi &&
    (singleCase.katathesi.includes("2022") ||
      singleCase.katathesi.includes("2023") ||
      singleCase.katathesi.includes("2024") ||
      singleCase.katathesi.includes("2025") ||
      singleCase.katathesi.includes("2026"))
  ) {
    prothesmies = returnProthArray(
      prothesmiesMikrodiaforon(singleCase.katathesi.replace(/\//g, "-"), {
        topiki: singleCase.topos,
        exoterikou: userInput.exoterikou === "Ναι",
        dimosio: userInput.dimosio === "Ναι",
      })
    ).filter(hasUsableDate);
  } else if (
    katathesiIsoDate &&
    isEidikesCase(
      {
        diadikasia: singleCase?.diadikasia,
        antikeimeno: singleCase?.antikeimeno,
        eidos: singleCase?.eidos,
      },
      katathesiIsoDate
    )
  ) {
    prothesmies = returnProthArray(
      prothesmiesNeasTaktikis(singleCase.katathesi.replace(/\//g, "-"), {
        mode: "eidikes",
        dikasimos: userInput.dikasimos.replace(/\//g, "-"),
        topiki: singleCase.topos,
        yliki: dikastirioIndex[singleCase.dikastirio],
        exoterikou: userInput.exoterikou === "Ναι",
        dimosio: userInput.dimosio === "Ναι",
      })
    ).filter(hasUsableDate);
  }
  const diakinisi =
    singleCase?.extra_info?.diakinisi &&
    JSON.parse(singleCase.extra_info.diakinisi).length > 0 &&
    JSON.parse(singleCase.extra_info.diakinisi)[0].imnia_apostolis !== ""
      ? JSON.parse(singleCase.extra_info.diakinisi)
      : undefined;
  const appeals =
    singleCase?.extra_info?.appeals &&
    JSON.parse(singleCase.extra_info.appeals).length > 0 &&
    JSON.parse(singleCase.extra_info.appeals)[0].etos_endikou !== ""
      ? JSON.parse(singleCase.extra_info.appeals)
      : undefined;
  const dimosiefseis =
    singleCase?.extra_info?.dimosiefseis &&
    JSON.parse(singleCase.extra_info.dimosiefseis).length > 0 &&
    JSON.parse(singleCase.extra_info.dimosiefseis)[0].imnia_dimosiefsis !== ""
      ? JSON.parse(singleCase.extra_info.dimosiefseis)
      : undefined;

  const stoixeia_dikasimou = singleCase?.extra_info?.stoixeia_dikasimou
    ? JSON.parse(singleCase.extra_info.stoixeia_dikasimou)
    : undefined;
  const lawyers = singleCase?.extra_info?.lawyers
    ? JSON.parse(singleCase.extra_info.lawyers)
    : undefined;
  const applicants = singleCase?.extra_info?.applicants
    ? JSON.parse(singleCase.extra_info.applicants)
    : undefined;
  const defendants = singleCase?.extra_info?.defendants
    ? JSON.parse(singleCase.extra_info.defendants)
    : undefined;

  return (
    <section className="kartela-solon">
      <section className="stoixeia-dikasimos-prothesmies">
        <article className="stoixeia-ypothesis">
          <p>Καρτέλα Υπόθεσης</p>

          {singleCase?.note?.trim() ? (
            <h1>{singleCase?.note}</h1>
          ) : (
            <h1>
              {singleCase.dikastirio} {singleCase?.topos}
            </h1>
          )}
          {singleCase?.note?.trim() && (
            <h2>
              {singleCase.dikastirio} {singleCase?.topos}
            </h2>
          )}
          <Detail
            singleCase={singleCase}
            name="Διαδικασία"
            property="diadikasia"
            modifySingleCase={modifySingleCase}
            diadikasies={diadikasies}
            antikeimena={antikeimena}
            saveCase={saveCase}
          />
          <Detail
            singleCase={userInput}
            name="Αντικείμενο"
            property="antikeimeno"
            modifySingleCase={modifySingleCase}
            diadikasies={diadikasies}
            antikeimena={antikeimena}
            saveCase={saveCase}
          />

          <Detail
            singleCase={userInput}
            name="Είδος"
            property="eidos"
            modifySingleCase={modifySingleCase}
            eidi={eidi}
            saveCase={saveCase}
          />
          <Detail
            singleCase={singleCase}
            name="Ημ/νία Κατάθεσης"
            property="katathesi"
            modifySingleCase={modifySingleCase}
            saveCase={saveCase}
          />
          <Detail
            singleCase={userInput}
            name="Πινάκιο"
            property="pinakio"
            saveCase={saveCase}
            modifySingleCase={modifySingleCase}
          />

          <Detail
            singleCase={userInput}
            name="Αποτέλεσμα"
            property="apotelesma"
            saveCase={saveCase}
            modifySingleCase={modifySingleCase}
          />
          <Detail
            singleCase={userInput}
            name="Αριθμός Απόφασης"
            property="ar_apofasis"
            saveCase={saveCase}
            modifySingleCase={modifySingleCase}
          />

          {dimosiefseis && (
            <>
              <h3>Τύπος Διατακτικού:</h3>
              <p className="stoixeia-text">
                {dimosiefseis[0].typos_diataktikou}
              </p>
              <h3>Ημ/νία Δημοσίευσης:</h3>
              <p className="stoixeia-text">
                {dimosiefseis[0].imnia_dimosiefsis}
              </p>
              <h3>Δια ταύτα:</h3>
              {dimosiefseis[0].dia_tafta.trim() ? (
                <p className="stoixeia-text">{dimosiefseis[0].dia_tafta}</p>
              ) : (
                <p className="stoixeia-text empty">---</p>
              )}
            </>
          )}
          <h3>Δημιουργήθηκε στις:</h3>
          {singleCase?.created_at?.trim() ? (
            <p className="stoixeia-text">
              {formatDate(singleCase?.created_at)}
            </p>
          ) : (
            <p className="stoixeia-text empty">---</p>
          )}
          {/* <h3>Τελευταίος έλεγχος για ενημερώσεις στις:</h3>
          {singleCase?.last_checked?.trim() ? (
            <p className="stoixeia-text">
              {formatDate(singleCase?.last_checked)}
            </p>
          ) : (
            <p className="stoixeia-text empty">---</p>
          )}
          {diakinisi && <h3>Διακίνηση Υπόθεσης:</h3>}
          {diakinisi && (
            <p className="stoixeia-text">
              Τμήμα: {diakinisi.at(-1).tmima_pros} - Ημ/νία:{" "}
              {diakinisi.at(-1).imnia_apostolis}
            </p>
          )}
          {appeals && <h3>Ένδικα Μέσα:</h3>}
          {appeals && (
            <p className="stoixeia-text">
              Είδος: {appeals.at(-1).eidos} - ΓΑΚ: {appeals.at(-1).gak_endikou}{" "}
              - Έτος: {appeals.at(-1).etos_endikou}
            </p>
          )}
          <h3>Τελευταίος έλεγχος Διακίνησης και Ενδίκων Μέσων στις:</h3>
          {singleCase?.extra_info?.last_checked?.trim() ? (
            <p className="stoixeia-text">
              {formatDate(singleCase?.extra_info?.last_checked)}
            </p>
          ) : (
            <p className="stoixeia-text empty">---</p>
          )} */}
        </article>
        <section className="dikasimos-prothesmies">
          <article className="dikasimos">
            <Detail
              singleCase={userInput}
              name="Δικάσιμος"
              property="dikasimos"
              modifySingleCase={modifySingleCase}
              saveCase={saveCase}
            />
          </article>
          <article className="prothesmies-kartela">
            <h2>Προθεσμίες</h2>
            {prothesmies.length ? (
              prothesmies.map((r) => (
                <ProthesmiaRow key={r.eidos} proth={r} />
              ))
            ) : (
              <p className="prothesmies-text">---</p>
            )}

            {/* {imerominia.trim() ? <p className='stoixeia-text'>{imerominia}</p> : <p className='stoixeia-text empty'>---</p>} */}
          </article>
        </section>
      </section>
      <section className="solon-info">
        {lawyers && <Lawyers data={lawyers} />}
        {applicants && <Applicants data={applicants} />}
        {defendants && <Defendants data={defendants} />}
        {stoixeia_dikasimou && <StoixeiaDikasimou data={stoixeia_dikasimou} />}
        {appeals && <Appeals data={appeals} />}
        {diakinisi && <Diakinisi data={diakinisi} />}

        <Container handleChange={handleInputChange} userInput={userInput} />
      </section>
    </section>
  );
};

export default VSolonCard;
